export default __webpack_public_path__ + "static/media/Outfit-Bold.b2e2fcd8.ttf";